import React from 'react'
import { TextField, Box } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import { Formik, FormikProps } from 'formik'

import { LoadableButton, PhoneField } from '../../../components/Form'
import { loginSchema } from './validation'

export interface ILoginFormValues {
  phone: string
  password: string
}

interface IProps {
  onSubmit: (values: ILoginFormValues) => void
  loading?: boolean
}

export const LoginForm: React.FC<IProps> = ({ onSubmit, loading }) => {
  const classes = useStyles()
  const initialValues: ILoginFormValues = {
    phone: '',
    password: '',
  }

  const handleFormSubmit = (values: ILoginFormValues) => {
    onSubmit(values)
  }

  return (
    <Formik initialValues={initialValues} validationSchema={loginSchema} onSubmit={handleFormSubmit}>
      {({ values, errors, setFieldValue, handleChange, handleSubmit }: FormikProps<ILoginFormValues>) => (
        <form className={classes.form} onSubmit={handleSubmit}>
          <PhoneField
            label='Телефон'
            name='phone'
            value={values.phone}
            onChange={e => setFieldValue('phone', `+${e.target.value.replace(/\D+/g, '')}`)}
            error={!!errors.phone}
            required
            fullWidth
            margin='normal'
          />
          <TextField
            label='Пароль'
            name='password'
            value={values.password}
            onChange={handleChange}
            error={!!errors.password}
            required
            type='password'
            fullWidth
            margin='normal'
          />
          <Box mt={3}>
            <LoadableButton loading={loading} color='primary' variant='contained' fullWidth type='submit'>
              Войти
            </LoadableButton>
          </Box>
        </form>
      )}
    </Formik>
  )
}

const useStyles = makeStyles(theme => ({
  form: {
    width: '100%',
  },
}))
